import { Tooltip, TooltipProps } from "antd";
import React from "react";

interface IProps {
  children: React.ReactNode | string;
  title: string;
  /** Pass `false` to keep the tooltip closed; leave undefined for the normal hover behaviour. */
  open?: boolean;
  placement?:
    | "top"
    | "left"
    | "right"
    | "bottom"
    | "topLeft"
    | "topRight"
    | "bottomLeft"
    | "bottomRight"
    | "leftTop"
    | "leftBottom"
    | "rightTop"
    | "rightBottom";
}
const TooltipUI = (props: IProps) => {
  //! state
  const { children, title, placement = "top", open } = props;
  //! function
  //! render
  return (
    <Tooltip placement={placement} arrow={false} title={title} color="#232735" {...(open === false ? { open: false } : {})}>
      {children}
    </Tooltip>
  );
};

export default TooltipUI;
